import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { IRulesAndRegulationPagePublishedActivity } from './interfaces';
import { Trans } from 'react-i18next';
import { CardMedia } from '@mui/material';
import { ROUTES } from '@routes/routes';
import { useNavigate } from 'react-router';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

export const RulesAndRegulationPagePublishedActivity: React.FC<
  IRulesAndRegulationPagePublishedActivity
> = ({ title, date, slug, coverImageId }): JSX.Element => {
  const navigate = useNavigate();

  const activityTitle = (
    <Trans
      i18nKey={'activities:rulesAndRegulationsPagePublished.title'}
      values={{
        title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={date}
      icon={HealthAndSafetyIcon}
      onClick={() =>
        navigate(ROUTES.portal.association.rulesAndRegulations.details(slug))
      }
    >
      {coverImageId && (
        <CardMedia component="img" image={ROUTES.images.image(coverImageId)} />
      )}
    </ActivityPost>
  );
};
